
enum HorizontalAlignEnum {
    Left = 1,
    Center = 2,
    Right = 3
}
export default HorizontalAlignEnum
